<template lang="pug">
Transition(name="bignews-shell")
  #bignews(v-show="showNewsBanner")
    div.news-row.flex.items-center.justify-center(v-for="news in validNews" :key="news.id")
      div.icon.hidden(class="sm:block w-1/12")
        p
          Icon(name="material-symbols:mark-email-unread-outline-rounded")
      div.clickable.title.flex-1(@click="showNews(news)")
        button.mobile-dismiss(type="button" :aria-label="$t('iknew')" @click.stop="doNotShow(news)")
          Icon.mobile-dismiss-icon(name="lucide:x" aria-hidden="true")
        p {{ getAttr(news, 'title') }}
      LazyBigNewsModal(v-model:visible="newsModalVisible[news.id]" :news="news")
</template>

<script lang="ts" setup>
const user = useUser()
const session = useVisitorSession()
const isAdmin = toRef(session, 'isAdmin')
const $route = useRoute()
const i18n = useI18n()
const $t = i18n.t
const { hasRead: hasReadId, markRead } = useBigNewsRead()
const newsModalVisible = ref({} as { [key: number]: boolean })
// const rawNews = ref([] as knowledgesAttributes[])
// onMounted(() => {
//   execute()
// })
const getNews = async () => {
  const ret = (await useKnowledge.getLastestNews({ history: 1 }))
  if (ret) {
    // rawNews.value = ret
    for (const news of ret) {
      newsModalVisible.value[news.id] = false
    }
    return ret
  }
  return []
}

const { data: rawNews } = useAsyncData('news', getNews, { immediate: true })
// const { width, height } = useWindowSize()

// function fontSize(content) {
//   let size = 70 / content.length
//   const maxSize = 1.8
//   const minSize = 1.2
//   if (size > maxSize) {
//     size = maxSize
//   }
//   if (size < minSize) {
//     size = minSize
//   }
//   return `${(size / 290) * width.value}px`
// }
const isShowingNews = computed(() => {
  return Object.values(newsModalVisible.value).includes(true) || false
})
function showNews(news) {
  newsModalVisible.value[news.id] = true
}
function hasRead(news) {
  return hasReadId(news.id)
}

function doNotShow(news) {
  markRead(news.id)
  newsModalVisible.value[news.id] = false
}
function getAttr(obj, key) {
  return obj[`${key}_${i18n.locale.value}`] || obj[key]
}

const showNewsBanner = computed(() => {
  if (isShowingNews.value) {
    // console.log('is showing news!!!')
    return false
  }
  if (!validNews.value.length) {
    // console.log('no valid news!!!!')
    return false
  }
  if (String($route.name)?.startsWith('knowledges')) {
    // console.log('in knowledges, do not show!!!')
    return false
  }
  if (isAdmin.value) {
    if (session.id !== user.id) {
      // console.log('user is not session. will NOT show news.')
      return false
    }
  }
  return true
})

const validNews = computed(() => {
  const ret = rawNews.value?.filter?.(news => !hasRead(news) && !news.expired && news.id !== 108) || []
  // console.log('!!!!!!!!!!!!!!VALID NEWS IS:', rawNews)
  // return rawNews.value || []
  return ret
})
</script>

<style lang="postcss" scoped>
#bignews {
  width: 100%;
  max-width: var(--primary-max-width);
  /* left: 2%; */
  left: 50%;
  transform: translateX(-50%);
  top: 3.2rem;

  @media (min-width: 768px) {
    top: 4.2rem;
    width: 100%;
  }

  /* bottom: 0; */
  /* margin: 0px 0 20px; */
  margin: 0;
  text-align: left;
  position: fixed;
  z-index: 100;
  /* --alert-color: var(--carrot); */
  --alert-color: rgb(255, 165, 87);

  .headline {
    color: var(--alert-color);
    font-weight: bold;
  }

  .news-row {
    position: relative;
    width: 100%;
    border-radius: 0.625rem;
    text-align: left;
    animation: bignews-bounce 2s ease-in-out infinite;

    &:not(:last-of-type) {
      margin-bottom: 40px;
    }

    > div {
      box-shadow: 0 10px 15px var(--card-shadow), 0 5px 15px rgba(0, 0, 0, 0.07) !important;
    }

    .icon {
      background: var(--alert-color);
      height: 54px;
      vertical-align: middle;
      text-align: center;
      width: 70px;
      /* border-radius: 0.625rem; */
      /* border: 0px solid var(--alert-color); */
      border: none;
      border-top-left-radius: 0.625rem;
      border-bottom-left-radius: 0.625rem;

      p {
        font-size: 35px;
        padding: 4px;
        margin: 5px auto;
        color: #ffffff;
      }

      @media (max-width: 900px) {
        display: none;
      }
    }

    .title {
      position: relative;

      @media (max-width: 900px) {
        /* display: none; */
        border: 2px solid var(--alert-color);
        border-radius: 0.625rem;
      }

      border-top-right-radius: 0.625rem;
      border-bottom-right-radius: 0.625rem;
      border: 2px solid var(--alert-color);
      background: var(--revert-bg);

      p {
        /* padding-left: 10px; */
        /* color: var(--revert-primary); */
        color: var(--alert-color);
        font-weight: 700;
        font-size: 28px;
        padding: 15px 0 15px 15px;
        line-height: 20px;

        @media (max-width: 768px) {
          font-size: 1rem;
          /* padding:  */
          padding: 10px 42px 10px 10px;
        }
      }

      .mobile-dismiss {
        position: absolute;
        right: 0.5rem;
        top: 50%;
        transform: translateY(-50%);
        cursor: pointer;
        border: 0;
        border-radius: 999px;
        background: var(--alert-color);
        color: #ffffff;
        width: 1.6rem;
        height: 1.6rem;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0;

        .mobile-dismiss-icon {
          font-size: 0.95rem;
          line-height: 1;
        }
      }
    }
  }
}

.bignews-shell-enter-active,
.bignews-shell-leave-active {
  transition:
    opacity 220ms ease,
    transform 260ms cubic-bezier(0.22, 1, 0.36, 1);
}

.bignews-shell-enter-from,
.bignews-shell-leave-to {
  opacity: 0;
  transform: translateX(-50%) translateY(-14px);
}

.bignews-shell-enter-to,
.bignews-shell-leave-from {
  opacity: 1;
  transform: translateX(-50%) translateY(0);
}

@keyframes bignews-bounce {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-6px);
  }
}
</style>
